// Helper to safely emit Meta Pixel (fbq) events.
// The pixel is loaded in index.html. This wrapper avoids TS errors and
// guards against environments where fbq isn't available (SSR, blockers).

type FbqParams = Record<string, unknown>;

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

export const fbqTrack = (event: string, params?: FbqParams) => {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.fbq !== "function") return;
    if (params) window.fbq("track", event, params);
    else window.fbq("track", event);
  } catch {
    // no-op: never let tracking break the app
  }
};
